import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";
import { qk } from "../keys";
import type { Site, SiteList } from "../models";

/** 사이트 신선도 집계(§4)도 노드와 같은 주기로 늙는다 — 같은 30초. */
const LIVE_REFETCH_MS = 30_000;

export function useSites(params?: { is_active?: boolean; search?: string }) {
  return useQuery({
    queryKey: qk.sites.list(params),
    queryFn: () => api.get<SiteList>("/sites/", { params }).then((r) => r.data),
    refetchInterval: LIVE_REFETCH_MS,
  });
}

export function useSite(id: number | undefined) {
  return useQuery({
    queryKey: id ? qk.sites.detail(id) : qk.sites.detail(-1),
    queryFn: () => api.get<Site>(`/sites/${id}/`).then((r) => r.data),
    enabled: !!id,
    refetchInterval: LIVE_REFETCH_MS,
  });
}

export function useCreateSite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Partial<Site>) =>
      api.post<Site>("/sites/", body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.sites.all }),
  });
}

export function useUpdateSite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }: Partial<Site> & { id: number }) =>
      api.patch<Site>(`/sites/${id}/`, body).then((r) => r.data),
    onSuccess: (data) => {
      qc.invalidateQueries({ queryKey: qk.sites.all });
      qc.setQueryData(qk.sites.detail(data.id!), data);
    },
  });
}
